import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ChunkErrorBoundary } from "@/shared/ui/components/ChunkErrorBoundary";
import "@/shared/i18n";
import "@/app/styles/tokens.css";
import "@/app/styles/global.css";
import "@/app/styles/intent-badge.css";
import "@/app/styles/mode-selector.css";
import "@/app/globals.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found in document");
}

createRoot(rootElement).render(
  <StrictMode>
    <ChunkErrorBoundary>
      <App />
    </ChunkErrorBoundary>
  </StrictMode>,
);
